import { useNavigation } from '@/app/hooks'

type LinkProps = {
  to?: string
  openInNewTab?: boolean
  className?: string
} & React.HTMLProps<HTMLAnchorElement>

export function Link({ to, className, openInNewTab, ...rest }: LinkProps) {
  const navigate = useNavigation()

  const handleNavigate = () => {
    if (to) {
      if (openInNewTab) {
        window.open(to, '_blank')
      } else {
        navigate.push(to)
      }
    }
  }

  return (
    <a
      className={`!underline cursor-pointer text-themed-blue-500 hover:text-themed-info font-bold text-sm ${className}`}
      onClick={handleNavigate}
      {...rest}
    >
      {rest.children}
    </a>
  )
}
